<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="活动期数" prop="period" >
        <a-input v-model="form.period" placeholder="请输入活动期数" />
      </a-form-model-item>
      <a-form-model-item label="开始时间" prop="startDate" >
        <a-date-picker style="width: 100%" v-model="form.startDate" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="结束时间" prop="endDate" >
        <a-date-picker style="width: 100%" v-model="form.endDate" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="活动总提现额度" prop="quota" >
        <a-input v-model="form.quota" placeholder="请输入活动总提现额度" />
      </a-form-model-item>
<!--      <a-form-model-item label="活动剩余提现额度" prop="availableQuota" >-->
<!--        <a-input v-model="form.availableQuota" placeholder="请输入活动剩余提现额度" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="活动状态" prop="status" >-->
<!--        <a-select v-model="form.status" placeholder="请选择活动状态">-->
<!--          <a-select-option value="0">未开始</a-select-option>-->
<!--          <a-select-option value="1">进行中</a-select-option>-->
<!--          <a-select-option value="2">已结束</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getActivity, addActivity, updateActivity } from '@/api/withdrawal/activity'
import moment from "moment";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        period: null,

        startDate: null,

        endDate: null,

        quota: null,

        availableQuota: null,

        status: 0,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        period: [
          { required: true, message: '活动期数不能为空', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '开始时间不能为空', trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: '结束时间不能为空', trigger: 'blur' }
        ],
        quota: [
          { required: true, message: '活动总提现额度不能为空', trigger: 'blur' }
        ],
        availableQuota: [
          { required: true, message: '活动剩余提现额度不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '活动状态 0-未开始 1-进行中 2-已结束不能为空', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '备注不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        period: null,
        startDate: null,
        endDate: null,
        quota: null,
        availableQuota: null,
        status: 0,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getActivity({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log('提交',this.form)
          console.log('时间',this.form.startDate>this.form.endDate)
          if (this.form.startDate>this.form.endDate){
            this.$message.error(
              '开始时间不能大于结束时间',
              3
            )
            return
          }
          this.form.startDate = moment(this.form.startDate).format("YYYY-MM-DD")
          this.form.endDate = moment(this.form.endDate).format("YYYY-MM-DD")
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateActivity(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addActivity(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
